var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconError = function SvgIconError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DB0000",
    d: "M1.866 20.5 12 3l10.135 17.5zM4.45 19h15.1L12 6zM12 17.808q.344 0 .576-.232a.78.78 0 0 0 .232-.576.78.78 0 0 0-.232-.576.78.78 0 0 0-.576-.232.78.78 0 0 0-.575.232.78.78 0 0 0-.232.576q0 .343.232.576a.78.78 0 0 0 .575.232m-.75-2.616h1.5v-5h-1.5z"
  })));
};
export default SvgIconError;